/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import VideoPlayOverlayIcon from '@atlaskit/icon/core/video-play-overlay';
import { Pressable } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { useAudioPlayerStreamingContext } from '../../../context/AudioPlayerStreamingProvider';

const i18n = defineMessages({
	playButtonLabel: {
		id: 'audio.mini-play-button.play-button-label',
		defaultMessage: 'Play',
		description: 'The label for the play button',
	},
});

const styles = cssMap({
	playButton: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '32px',
		height: '32px',
		borderRadius: token('radius.full'),
		backgroundColor: token('color.background.neutral'),
	},
	playButtonHover: {
		'&:hover': {
			backgroundColor: token('color.background.neutral.hovered'),
		},
		'&:active': {
			backgroundColor: token('color.background.neutral.pressed'),
		},
	},
	playIcon: {
		display: 'inline-block',
		transform: 'scale(0.875)',
	},
});

export type MiniPlayButtonProps = {};

export const MiniPlayButton = () => {
	const { formatMessage } = useIntl();
	const { audioRef } = useAudioPlayerStreamingContext();

	const handleClick = () => {
		audioRef.current?.play();
	};

	return (
		<Pressable
			onClick={handleClick}
			xcss={cx(styles.playButton, styles.playButtonHover)}
			testId="miniplayer-mini-play-button"
		>
			<span css={styles.playIcon}>
				<VideoPlayOverlayIcon label={formatMessage(i18n.playButtonLabel)} />
			</span>
		</Pressable>
	);
};
